module.exports = __webpack_public_path__ + "img/stars-5--alt.24f71e9.svg";